
import * as Tooltip from "@radix-ui/react-tooltip";
import { useState, type ReactNode } from "react";

import styles from "./shell.module.css";

type Props = {
  enabled: boolean;
  content: ReactNode;
  describes?: boolean;
  children: ReactNode;
};

export function RailTooltip({ enabled, content, describes = true, children }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <Tooltip.Root open={enabled && open} onOpenChange={setOpen}>
      <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content side="right" sideOffset={8} className={styles.tooltip} aria-hidden={describes ? undefined : true}>
          {content}
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  );
}
